import { render, staticRenderFns } from "./WapReportDetail.vue?vue&type=template&id=db12e9c6&scoped=true"
import script from "./WapReportDetail.vue?vue&type=script&lang=js"
export * from "./WapReportDetail.vue?vue&type=script&lang=js"
import style0 from "./WapReportDetail.vue?vue&type=style&index=0&id=db12e9c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db12e9c6",
  null
  
)

export default component.exports